import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import TabLabelIcon from '@/components/TabLabel/TabLabelIcon';
import { isFieldDisabledBYPRRD } from '@/helpers/utils';
import { CampaignInfo } from '@/types';
import styles from './LabelDisabledByPDRS.module.scss';
import TooltipComponent from '../Tooltip/TooltipComponent';

interface LabelDisabledByPDRSProps {
  campaignInfo: CampaignInfo;
  label: string;
  fieldName: string;
}

const LabelDisabledByPDRS: React.FC<LabelDisabledByPDRSProps> = ({ campaignInfo, label, fieldName }): ReactNode | string => {
  const { t } = useTranslation();
  const isFieldDisabled = isFieldDisabledBYPRRD(campaignInfo, fieldName);

  if (!isFieldDisabled) {
    return t(label);
  }

  return (
    <>
      {t(label)}
      <TooltipComponent
        classes={{ tooltip: styles.TooltipFreeText }}
        arrow
        title={(<Typography variant="body2" component="span">{t('valueByPDRS')}</Typography>)}
      >
        <span className={styles.InfoIconContainer}>
          <TabLabelIcon isProvidedField />
          <div className={styles.PDRSLogo}>PDRS</div>
        </span>
      </TooltipComponent>
    </>
  );
};

export default LabelDisabledByPDRS;
